var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "on-clickaway",
          rawName: "v-on-clickaway",
          value: _vm.away,
          expression: "away"
        }
      ],
      staticClass: "tag-selector-container"
    },
    [
      _c(
        "span",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.searchEnabled,
              expression: "!searchEnabled"
            }
          ],
          staticClass:
            "btn btn-default form-control tag-selector-search-toggle",
          on: { click: _vm.enableSearch }
        },
        [
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.selectedTag,
                  expression: "!selectedTag"
                }
              ],
              staticClass: "text-muted"
            },
            [_vm._v("\n      " + _vm._s(_vm.placeholder) + "\n    ")]
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.selectedTag,
                  expression: "selectedTag"
                }
              ]
            },
            [
              _vm._v(
                "\n      " + _vm._s(_vm.selectedTagFormattedName) + "\n    "
              )
            ]
          ),
          _vm._v(" "),
          _c("i", { staticClass: "caret" })
        ]
      ),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.searchEnabled,
            expression: "searchEnabled"
          },
          {
            name: "model",
            rawName: "v-model",
            value: _vm.searchString,
            expression: "searchString"
          }
        ],
        ref: "searchInput",
        staticClass: "form-control tag-selector-search",
        attrs: {
          autocomplete: "off",
          type: "search",
          placeholder: _vm.searchPlaceholder,
          tabindex: "-1"
        },
        domProps: { value: _vm.searchString },
        on: {
          focus: function($event) {
            _vm.activeTab = 0
          },
          input: function($event) {
            if ($event.target.composing) return
            _vm.searchString = $event.target.value
          }
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.searchEnabled,
              expression: "searchEnabled"
            }
          ],
          staticClass: "tag-selector-explore-container"
        },
        [
          _c(
            "Tabs",
            {
              staticClass: "tag-selector-tabs-container",
              attrs: { "custom-nav-class": "nav-stacked" },
              model: {
                value: _vm.activeTab,
                callback: function($$v) {
                  _vm.activeTab = $$v
                },
                expression: "activeTab"
              }
            },
            [
              _c(
                "Tab",
                { attrs: { title: _vm.$t("SEARCH"), index: "0" } },
                [
                  (!_vm.searchFilteredTags || !_vm.searchFilteredTags.length) &&
                  _vm.recentlyUsedTags.length
                    ? _c("div", [
                        _c("div", {
                          directives: [
                            {
                              name: "t",
                              rawName: "v-t",
                              value: "RECENTLY_USED",
                              expression: "'RECENTLY_USED'"
                            }
                          ],
                          staticClass: "text-muted p-10 p-b-0"
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "tag-selector-recently-used" },
                          _vm._l(_vm.recentlyUsedTags, function(tag) {
                            return _c(
                              "a",
                              {
                                key: tag.tagType + tag.tagName,
                                staticClass: "btn btn-primary",
                                attrs: { title: "formatRecentTag(tag)" },
                                on: {
                                  click: function($event) {
                                    return _vm.selectTag(tag)
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.formatRecentTag(tag)) +
                                    "\n            "
                                )
                              ]
                            )
                          }),
                          0
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  (!_vm.searchFilteredTags || !_vm.searchFilteredTags.length) &&
                  !_vm.recentlyUsedTags.length
                    ? _c("div", {
                        directives: [
                          {
                            name: "t",
                            rawName: "v-t",
                            value: _vm.emptyTabPlaceholderText,
                            expression: "emptyTabPlaceholderText"
                          }
                        ],
                        staticClass: "p-10 m-t-1 text-muted"
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("TagTree", {
                    attrs: { tags: _vm.searchFilteredTags, "for-search": true },
                    on: { selectTag: _vm.selectTag }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm._l(_vm.tagSources, function(source, index) {
                return _c(
                  "Tab",
                  {
                    key: source,
                    attrs: { index: index + 1, title: _vm.camelCase(source) }
                  },
                  [
                    _c("TagTree", {
                      attrs: { tags: _vm.tags, "tag-source": source },
                      on: { selectTag: _vm.selectTag }
                    })
                  ],
                  1
                )
              })
            ],
            2
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("input", {
        staticClass: "tag-selector-offscreen tag-selector-search",
        attrs: {
          disabled: _vm.searchEnabled,
          type: "text",
          "aria-haspopup": "true",
          role: "button"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }